import { observer } from 'mobx-react-lite';
import useDimensions from 'react-cool-dimensions';
import { UnitsDisplay } from '../../../common/components/units-display';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { useContextMenuStateWrite } from '../../../queues/context/use-context-menu-state';
import { getEventQueueRowData } from '../../../queues/utils/get-event-queue-row-data';
import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';

export const EventQueueAssignedUnitsCell = observer(function EventQueueAssignedUnitsCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    const { observe, width } = useDimensions();
    const contextMenuStateWrite = useContextMenuStateWrite();

    return (
        <BaseQueueCell ref={observe}>
            <UnitsDisplay
                width={width}
                units={getEventQueueRowData(data)?.assignedUnits ?? []}
                enableContextMenu={true}
                contextMenuStateWrite={contextMenuStateWrite}
            />
        </BaseQueueCell>
    );
});
